import { c as _c } from "react/compiler-runtime";
import { DeleteIcon } from "@flat-ui";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
import { useProjectMemberActions } from "@hooks/projects/use-project-member-actions";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { canRemoveMember } from "@components/table/members/members-table-utils";
import { ProjectRemoveMenuButton } from "@components/table/members/project-remove-menu-button";
/** Provides a reusable "Remove member" menu option for project member tables */
export function useProjectRemoveMenuOption(t0) {
  const $ = _c(13);
  const {
    companyId,
    selectedProject
  } = t0;
  const projectMemberActions = useProjectMemberActions(selectedProject);
  const {
    canDeleteMemberFromCompany
  } = useHasUserValidRoleCompanyLevel();
  const hasRequiredIds = !!companyId && !!selectedProject;
  let t1;
  if ($[0] !== canDeleteMemberFromCompany || $[1] !== hasRequiredIds || $[2] !== projectMemberActions) {
    t1 = function shouldShowProjectRemove(member) {
      return canRemoveMember({
        member,
        hasRequiredIds,
        canRemoveFromProject: projectMemberActions.canRemove(member),
        canDeleteFromCompany: canDeleteMemberFromCompany && !FaroCoreApiUtils.Member.isTeam(member)
      });
    };
    $[0] = canDeleteMemberFromCompany;
    $[1] = hasRequiredIds;
    $[2] = projectMemberActions;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const shouldShowProjectRemove = t1;
  let t2;
  if ($[4] !== canDeleteMemberFromCompany || $[5] !== companyId || $[6] !== projectMemberActions || $[7] !== selectedProject || $[8] !== shouldShowProjectRemove) {
    const getMenuOption = function getMenuOption() {
      if (!companyId || !selectedProject) {
        return [];
      }
      return [{
        label: "Remove member",
        Icon: DeleteIcon,
        component: (member_0, onMenuClose) => <ProjectRemoveMenuButton companyId={companyId} project={selectedProject} member={member_0} onMenuClose={onMenuClose} canRemoveFromProject={projectMemberActions.canRemove(member_0)} canRemoveFromWorkspace={canDeleteMemberFromCompany} />,
        shouldShow: shouldShowProjectRemove
      }];
    };
    t2 = getMenuOption();
    $[4] = canDeleteMemberFromCompany;
    $[5] = companyId;
    $[6] = projectMemberActions;
    $[7] = selectedProject;
    $[8] = shouldShowProjectRemove;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== shouldShowProjectRemove || $[11] !== t2) {
    t3 = {
      projectRemoveMenuOption: t2,
      shouldShowProjectRemove
    };
    $[10] = shouldShowProjectRemove;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}